import { rippleSvg } from './rippleMark'

/**
 * Explicit, fixed document metadata. Never derived from the project or prompt
 * name — these values are the source of truth and are re-applied on load.
 */
export const PAGE_TITLE = 'Lentic — Assessment for AI-assisted work'

export const PAGE_DESCRIPTION =
  'Lentic runs candidates through an instrumented task where the AI is provided but the source documents are withheld, then produces the auditable record of how each person exercised judgement.'

/** The lockup, used as the share image. */
export const SHARE_IMAGE =
  'https://cdn.magicpatterns.com/uploads/hKyoiRxLvYpWPxftj89JFp/lentic-logo-horizontal-teal-navy.svg'

/** The ripple mark, teal on transparent, from the shared mark geometry. */
const FAVICON_SVG = rippleSvg('#12564f', 3.4)

function upsertMeta(key: 'name' | 'property', value: string, content: string) {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${key}="${value}"]`)
  if (!el) {
    el = document.createElement('meta')
    el.setAttribute(key, value)
    document.head.appendChild(el)
  }
  el.setAttribute('content', content)
}

function upsertIcon(rel: string, href: string, type?: string) {
  document.head
    .querySelectorAll(`link[rel="${rel}"]`)
    .forEach((node) => node.parentElement?.removeChild(node))

  const link = document.createElement('link')
  link.setAttribute('rel', rel)
  if (type) link.setAttribute('type', type)
  link.setAttribute('href', href)
  document.head.appendChild(link)
}

export function applyDocumentMetadata() {
  document.title = PAGE_TITLE
  document.documentElement.lang = 'en-GB'

  upsertMeta('name', 'description', PAGE_DESCRIPTION)

  upsertMeta('property', 'og:type', 'website')
  upsertMeta('property', 'og:site_name', 'Lentic')
  upsertMeta('property', 'og:title', PAGE_TITLE)
  upsertMeta('property', 'og:description', PAGE_DESCRIPTION)
  upsertMeta('property', 'og:image', SHARE_IMAGE)

  upsertMeta('name', 'twitter:card', 'summary_large_image')
  upsertMeta('name', 'twitter:title', PAGE_TITLE)
  upsertMeta('name', 'twitter:description', PAGE_DESCRIPTION)
  upsertMeta('name', 'twitter:image', SHARE_IMAGE)

  upsertMeta('name', 'theme-color', '#f4f1ea')

  const favicon = `data:image/svg+xml,${encodeURIComponent(FAVICON_SVG)}`
  upsertIcon('icon', favicon, 'image/svg+xml')
  upsertIcon('apple-touch-icon', favicon)
}
